import Navbar from '@/components/landing/Navbar';
import Hero from '@/components/landing/Hero';
import Problems from '@/components/landing/Problems';
import Services from '@/components/landing/Services';
import Differentials from '@/components/landing/Differentials';
import HowItWorks from '@/components/landing/HowItWorks';
import Plans from '@/components/landing/Plans';
import Testimonials from '@/components/landing/Testimonials';
import FAQ from '@/components/landing/FAQ';
import Footer from '@/components/landing/Footer';
import WhatsAppFloat from '@/components/landing/WhatsAppFloat';

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen">
      <Navbar />
      <Hero />
      <Problems />
      <Services />
      <HowItWorks />
      <Differentials />
      <Plans />
      <Testimonials />
      <FAQ />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
